import React from 'react';

import { forTemplate } from '@trello/i18n';
const format = forTemplate('notification_supplement');

const butlerFeaturesAndQuotasUrl =
  'https://help.trello.com/article/1181-butler-features-and-quotas';

export const ButlerFeaturesAndQuotasLink = (
  <a
    href={butlerFeaturesAndQuotasUrl}
    target="_blank"
    rel="noopener noreferrer"
  >
    {format('learn-more-about-butler-quotas')}
  </a>
);
